var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPathCss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.5001 119.697L24.8689 110.083L17.1514 23.5234H101.952L94.2269 110.07L59.5001 119.697Z",
    fill: "#264DE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6129 104.559L94.2145 30.6011H59.5518V112.338L87.6129 104.559Z",
    fill: "#2965F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8437 62.7041L35.795 73.3203H59.552V62.7041H34.8437ZM32.9316 41.2168L33.8966 51.833H59.552V41.2168H32.9316ZM59.552 90.2755L59.5055 90.2878L47.6823 87.0954L46.9264 78.6285H36.2694L37.7566 95.2976L59.5032 101.334L59.552 101.321V90.2755Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1094 0H49.967V5.37706H42.4864V10.7541H49.9676V16.1309H37.1094V0ZM52.5388 0H65.3968V4.67568H57.9159V5.61075H65.3968V16.3649H52.5392V11.4548H60.02V10.5198H52.5385V0H52.5388ZM67.9686 0H80.8265V4.67568H73.3457V5.61075H80.8265V16.3649H67.9686V11.4548H75.4495V10.5198H67.9689V0H67.9686Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1921 62.7041L86.1084 41.2168H59.515V51.833H74.4741L73.5081 62.7041H59.515V73.3203H72.5877L71.3551 87.0887L59.5146 90.2845V101.329L81.2785 95.2976L81.4381 93.5039L83.9332 65.5549L84.1921 62.7041Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathCss);
export default __webpack_public_path__ + "static/media/path-css.bb3d854d3699cbf50b836c2f34127931.svg";
export { ForwardRef as ReactComponent };